module.exports = __webpack_public_path__ + "static/media/assa-headset.15876262.svg";